import React, { useState, useEffect } from "react";
import SelectDropdown from "../../components/SelectDropdown";
import { RiAdminFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import toastMessage from "../../toast";
import Table from "../../components/Table/Table";
import { getUnSettledOrders } from "../../store/actions/admin-actions";

function PendingSettlement() {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    input: "",
    memberType: "Admin", // Default value for member type
  });

  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleCloseImageModal = () => {
    setSelectedImage(null);
  };

  const handleChange = (name, value) => {
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Select member details from Redux state
  const { adminInfo } = useSelector((state) => state.adminDetails);

  // useEffect to fetch data based on selected member type
  useEffect(() => {
    dispatch(getUnSettledOrders());
  }, [dispatch]);

  // Function to return data based on selected member type
  const getDataForUnSettledOrders = () => {
    return Array.isArray(adminInfo?.unsettled_order_items)
      ? adminInfo?.unsettled_order_items
      : []; // Return data from Redux store
  };
  // Function to handle manage button click
  //   const handleManage = (item) => {
  //     let payload = {
  //       memberId: item._id,
  //     };
  //     if (item.role !== "admin") {
  //       dispatch(DisableMember(payload));
  //     } else {
  //       toastMessage("error", "Admin cant be disable");
  //     }
  //   };

  return (
    <div>
      <div className="p-[25px] rounded-md border-[solid] border bg-white">
        <div className="border-b border-gray-100 px-4 py-4">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold text-gray-900">
              Pending Settlement
            </h2>
          </div>
        </div>
        <div className="overflow-x-auto w-full">
          <Table
            className="overflow-x-auto w-full"
            header={[
              "Title",
              "Order ID",
              "Cancelled Item Price",
              "Total Cart Value",
              "Coupon Discount",
              "Wallet Money",
              "Delivery Fee",
              "GST",
              "Cancellation Reason",
            ]}
          >
            {getDataForUnSettledOrders()?.map((item, index) => (
              <tr
                key={index}
                className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
              >
                <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[12rem] ">
                  {item?.orderItemCategory?.name}
                </td>

                <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[12rem] ">
                  {item?.orderId}
                </td>
                <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[9rem]">
                  <p
                    className={`px-3 py-1 rounded-md text-sm font-medium bg-red-100 text-red-800 text-center w-[4rem] `}
                  >
                    {item.orderItemCategory?.price}
                  </p>
                </td>

                <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[9rem]">
                  <p
                    className={`px-3 py-1 rounded-md text-sm font-medium bg-green-100 text-green-800 text-center w-[5rem]`}
                  >
                    {item?.orderPaymentBreakdown?.cartValue}
                  </p>
                </td>

                <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[9rem]">
                  <p
                    className={`px-3 py-1 text-sm font-medium  text-center w-[5rem]`}
                  >
                    {item?.orderPaymentBreakdown?.couponDiscount.toFixed(2)}
                  </p>
                </td>

                <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[9rem]">
                  <p
                    className={`px-3 py-1 text-sm font-medium  text-center w-[5rem]`}
                  >
                    {item?.orderPaymentBreakdown?.walletDiscount}
                  </p>
                </td>

                <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[9rem]">
                  <p
                    className={`px-3 py-1 text-sm font-medium  text-center w-[5rem]`}
                  >
                    {item?.orderPaymentBreakdown?.deliveryFee}
                  </p>
                </td>

                <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[9rem]">
                  <p
                    className={`px-3 py-1 text-sm font-medium  text-center w-[5rem]`}
                  >
                    {item?.orderPaymentBreakdown?.gst}
                  </p>
                </td>

                <td className="py-2 px-4 text-sm text-gray-800 border-t min-w-[15rem]">
                  {item?.cancellationReason}
                </td>
              </tr>
            ))}
          </Table>
        </div>
      </div>
      {selectedImage && (
        <div className="fixed inset-0 z-[150] flex items-center justify-center bg-gray-500 bg-opacity-75">
          <div className="relative w-fit h-full">
            <div
              className="mx-auto flex w-[35px] h-[35px] absolute right-4 top-4 flex-shrink-0 items-center justify-center rounded-full bg-red-100 cursor-pointer"
              onClick={handleCloseImageModal}
            >
              <svg
                className="h-6 w-6 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 6l12 12M6 18L18 6"
                />
              </svg>
            </div>
            <img
              src={selectedImage}
              alt="Selected"
              className="max-w-[100%] max-h-[100%] object-contain cursor-pointer"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default PendingSettlement;
